import React from 'react';
// import './JobCard.css';

const JobCard = ({ job }) => {
  return (
    <div className="job-card" data-department={job.department}>
      <h3>{job.title}</h3>
      <div className="job-meta">
        <span><i className="fas fa-map-marker-alt"></i> {job.location}</span>
        <span><i className="fas fa-briefcase"></i> {job.type}</span>
        <span><i className="fas fa-calendar-alt"></i> {job.posted}</span>
      </div>
      <div className="job-description">
        <p>{job.description}</p>
      </div>
      <a href="#" className="apply-btn">Apply Now</a>
    </div>
  );
};

export default JobCard;